<template>
  <ModalDialog
    ref="dialog"
    :title="title"
    icon="fa-layer-group"
    sizeClass="modal-xl"
    :showFooter="true"
    closeTitle="Close"
    :showSubmit="false"
    @closed="onClosed">

    <LoadingPanel ref="loadingPanel" @update="loading = $event" />
    <div class="float-right">
      <ActionDropMenu>
        <DropdownMenuItem icon="fa-layer-plus" @click="addOffcutClicked" v-if="panelList.length > 0">Add Offcut</DropdownMenuItem>
      </ActionDropMenu>
    </div>
    <ContentTitle>Panel List</ContentTitle>
    <Scroller :maxHeight="500">
      <StaticDataTable class="static-table-list station-table-med" v-if="!loading">
        <template v-slot:header>
          <tr>
            <th>Panel</th>
            <th>Size (HxW)</th>
            <th>Order</th>
            <th>Order Status</th>
            <th>Hold Reason</th>
            <th>Mark</th>
          </tr>
        </template>
        <template v-slot:body>
          <tr v-for="panel of panelList" :key="panel.id">
            <td>{{panel.barcode}}</td>
            <td>{{panel.panelHeight}} x {{panel.panelWidth}}</td>
            <td>{{panel.orderSequenceNumber}}</td>
            <td>
              <LabelOrderStatusBadge :status="panel.orderStatus" :isOnHold="panel.orderIsOnHold" :holdType="panel.orderHoldType" />
            </td>
            <td>{{formatHyphenEmptyValue(panel.orderIsOnHold ? panel.orderHoldReason : '')}}</td>
            <td>{{formatHyphenEmptyValue(panel.orderItemMark)}}</td>
          </tr>
        </template>
        <template v-slot:empty v-if="panelList.length == 0">No unallocated panels</template>
      </StaticDataTable>
    </Scroller>
  </ModalDialog>
</template>

<style scoped>

</style>

<script>
import _ from 'lodash'

import form from '@/mixins/form'
import ModalDialog from '@/components/modalDialog.vue'
import modalDialog from '@/mixins/modalDialog'

import LabelOrderStatusBadge from '@/modules/orders/components/labelOrderStatusBadge'
import GlassAddOffcutDialog from '@/apps/glass-production-station/src/views/glassAddOffcutDialog'

export default {
  name: 'OptimiserUnallocPanelsDialog',
  mixins: [
    modalDialog,
    form
  ],
  components: {
    ModalDialog,
    LabelOrderStatusBadge
  },
  props: {
    productionStationId: Number,
    stockName: String,
    stockId: Number
  },
  data() {
    return {
      loading: true,
      panelList: []
    }
  },
  watch: {
  },
  created() {
  },
  mounted() {
  },
  computed: {
    title() {
      return `Unallocated Panels for ${this.stockName}`
    }
  },
  methods: {
    show(params) {
      this.submitting = false

      this.requestData()

      return modalDialog.methods.show.call(this, arguments)
    },
    onClosed() {
      this.modalClosed(null)
    },
    requestData() {
      this.$refs.loadingPanel.startLoading()

      this.$apiService.glassProductionStationService.getOptimiserUnallocPanelsList(this.productionStationId, this.stockId)
      .then(response => {        
        this.panelList = response.data
      })
      .catch(err => {
        this.$refs.loadingPanel.setError('Error loading list', err)        
      })
      .finally(() => {
        this.$refs.loadingPanel.finishedLoading()
      })
    },
    addOffcutClicked() {
      this.hide(() => {
        // Display add offcut dialog
        this.displayModal(GlassAddOffcutDialog, { 
          stockId: this.stockId,
          stockName: this.stockName,
          productionStationId: this.productionStationId
        }, {}, { mountBody: true })
        .then(() => {
        })
      })
    }
  }
}
</script>